import MlsFetchSavedSearchesMixins from './mixins/MlsStaticSearchFilterMixins';
import MlsStaticSearchFilterMixins from './mixins/MlsFetchSavedSearchesMixins';

export default {
  MlsFetchSavedSearchesMixins,
  MlsStaticSearchFilterMixins,
};
